import { ListaInscritosEidu as Lista } from "containers/Admin/ListaInscritosEidu";

export default function AdminPage() {
  return <Lista />;
}
